/**
 * RelatorioGeracao
 * @author Simpli CLI generator
 */
import {$, Helper, Request, Resource} from 'simpli-web-sdk'
import {ResponseSerialize} from 'simpli-web-sdk'
import {Responsavel} from '@/model/resource/Responsavel'
import {TipoRelatorio} from '@/model/resource/TipoRelatorio'
import {RelatorioGeracaoCollection} from '@/model/collection/RelatorioGeracaoCollection'

/* TODO: review generated class */
export class RelatorioGeracao extends Resource {
  idRelatorioGeracaoPk: number = 0

  @ResponseSerialize(Responsavel)
  responsavel: Responsavel | null = null

  @ResponseSerialize(TipoRelatorio)
  tipoRelatorio: TipoRelatorio | null = null

  dataCriacao: string | null = null

  urlDownload: string | null = null
  dataGeracaoRelatorio: string | null = null

  get $id() {
    return this.idRelatorioGeracaoPk
  }
  set $id(val) {
    this.idRelatorioGeracaoPk = val
  }

  get idResponsavelFk() {
    if (!this.responsavel) return 0
    return this.responsavel.$id
  }
  set idResponsavelFk(val) {
    if (!this.responsavel) this.responsavel = new Responsavel()
    this.responsavel.$id = val
  }

  get idTipoRelatorioFk() {
    if (!this.tipoRelatorio) return 0
    return this.tipoRelatorio.$id
  }
  set idTipoRelatorioFk(val) {
    if (!this.tipoRelatorio) this.tipoRelatorio = new TipoRelatorio()
    this.tipoRelatorio.$id = val
  }

  /**
   * Gets a instance of a given ID of RelatorioGeracao
   */
  async getRelatorioGeracao(id: number) {
    return await Request.get(`/admin/relatorio-geracao/${id}`)
      .name('getRelatorioGeracao')
      .as(this)
      .getData()
  }

  /**
   * Lists the instances of RelatorioGeracao
   */
  static async listRelatorioGeracao(params: any) {
    return await Request.get(`/admin/relatorio-geracao`, {params})
      .name('listRelatorioGeracao')
      .as(RelatorioGeracaoCollection)
      .getData()
  }

  /**
   * Persists a new instance of RelatorioGeracao. Use ID = 0 to create a new one,
   * or ID > 0 to update a current one
   */
  async persistRelatorioGeracao() {
    return await Request.post(`/admin/relatorio-geracao`, this)
      .name('persistRelatorioGeracao')
      .asNumber()
      .getData()
  }

  /**
   * Lists the instances of RelatorioGeracao to use it in a CSV file
   */
  static async listCsvRelatorioGeracao(params: any) {
    return await Request.get(`/admin/relatorio-geracao/csv`, {params})
      .name('listCsvRelatorioGeracao')
      .as(RelatorioGeracaoCollection)
      .getData()
  }
}
